"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Leaf = void 0;
const react_1 = __importDefault(require("react"));
function Leaf({ attributes, children, leaf }) {
    if (leaf.bold) {
        children = react_1.default.createElement("strong", null, children);
    }
    if (leaf.code) {
        children = react_1.default.createElement("code", null, children);
    }
    if (leaf.italic) {
        children = react_1.default.createElement("em", null, children);
    }
    if (leaf.underline) {
        children = react_1.default.createElement("u", null, children);
    }
    if (leaf.link) {
        children = (react_1.default.createElement("a", { href: leaf.link.url, "data-name": leaf.link.name, "data-content-type": leaf.link.contentType, "data-size": leaf.link.size, target: "_blank", rel: "noreferrer" }, children));
    }
    return react_1.default.createElement("span", { ...attributes }, children);
}
exports.Leaf = Leaf;
//# sourceMappingURL=leaf.js.map